import {
  DELETE_CONTENT,
  isOpenSuggestionChange,
  isRejectedChange,
} from "../../../../helpers/Doc/changes";

const NORMAL_COLOR = "black";
const ALERT_COLOR = "#B60000"; // #B60000 is a dark red color that satisfies contrast rules

export const getAlertStyle = (isAlert: boolean) => {
  return isAlert
    ? { color: ALERT_COLOR, fontWeight: "bold" }
    : { color: NORMAL_COLOR };
};

export function getLabValuesTableRowDeleteUiState(
  row: {
    addDeleteChanges?: Array<BaseClothedChange & { type: string }>;
  },
  blockChangeHighlight?: BlockChangeHighlight
) {
  const isDelete = blockChangeHighlight?.type === DELETE_CONTENT;
  const disableDeleteButton = (row.addDeleteChanges || []).some(
    (change) =>
      change.type === DELETE_CONTENT &&
      (isOpenSuggestionChange(change) ||
        (!change.is_suggestion && !isRejectedChange(change)))
  );

  return { isDelete, disableDeleteButton };
}
